import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '产品服务',
    links: [
      { label: '核心产品', path: '/categories?tab=products' },
      { label: '解决方案', path: '/categories?tab=solutions' },
      { label: '技术支持', path: '/categories?tab=support' },
    ],
  },
  {
    title: '关于clsq',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '品牌信誉', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', path: '/#faq' },
      { label: '服务条款', path: '/article/terms' },
      { label: '隐私政策', path: '/article/privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <span className="text-xl font-heading font-bold text-background-50">clsq</span>
            <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-xs">
              clsq致力于为客户提供高品质的产品与服务，以创新驱动发展，以诚信赢得信赖。选择clsq，选择放心。
            </p>
          </div>

          {/* Links */}
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} clsq. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-background-400 hover:text-accent-400 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}